import React from 'react'

function PopularCategoryButton() {
    return (
        <>
            <a href='#' id='PopularButton' type='button' 
            className="btn btn-sm btn btn-bg product-view-button popular-btn"> More View</a>
        </>
    )
}

export default PopularCategoryButton;
